import {
  Box,
  LinearProgress,
  linearProgressClasses,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";

type ProgressTrackerProps = {
  currentStep: number;
};

type SingleProgressTrackerProps = {
  name: string;
  active: boolean;
  last: boolean;
};

const StyledLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: "0.25rem",
  width: "100%",
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: theme.palette.text.secondary,
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 5,
    backgroundColor: theme.palette.primary.main,
  },
}));

const SingleProgressTracker = ({
  name,
  active,
  last,
}: SingleProgressTrackerProps) => {
  return (
    <Box
      sx={{
        display: "contents",
        "@media (max-width: 600px)": {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 0.5,
          flex: "0 0 calc((100% - 3 * clamp(0.375rem, 1.5vw, 0.75rem)) / 4)",
        },
      }}
    >
      <StyledLinearProgress variant="determinate" value={active ? 100 : -10} />
      <Typography
        sx={{
          flexShrink: 0,
          marginRight: last ? 0 : "clamp(0.5rem, 1vw, 0.75rem)",
          color: active ? "primary.main" : "text.secondary",
          fontSize: "0.75rem",
          "@media (max-width: 600px)": {
            marginRight: 0,
            textAlign: "center",
          },
        }}
      >
        {name}
      </Typography>
    </Box>
  );
};

export const ProgressTrackerHeader = ({ currentStep }: ProgressTrackerProps) => {
  const trackerTitles: string[] = [
    "Welcome",
    "Role",
    "Tool",
    "Level",
    "Task",
    "Practice",
    "Complete",
  ];

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(7, minmax(1rem, 1fr) max-content)",
        alignItems: "center",
        backgroundColor: "#1A1A1A",
        height: "2.875rem",
        px: "2vw",
        columnGap: "3px",
        "@media (max-width: 600px)": {
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          alignContent: "center",
          height: "auto",
          minHeight: "5.75rem",
          py: 1.25,
          columnGap: "clamp(0.375rem, 1.5vw, 0.75rem)",
          rowGap: 1.25,
        },
      }}
    >
      {trackerTitles.map((listItem, index) => (
        <SingleProgressTracker
          key={listItem}
          name={listItem}
          active={index <= currentStep}
          last={index === trackerTitles.length - 1}
        />
      ))}
    </Box>
  );
};
